import React, { Component } from 'react';
import { request } from 'http';

export default class Head extends Component {
	render() {
		const {q, t,l} = this.props
		return <div style={{
		}}>
			<div style={{
				position:"fixed",
				left: l+2,
				top: t+2,
				width:360,
				height:20,
				// backgroundColor:global.blue,
				zIndex:100,
			}}/>
			<div style={{
				position:"absolute",
				left: 20,
				top: 60,
				width:360 - 48,
				height:100,
			}}>
				<p style={{
					fontSize:16,
					color:"#BDBDBD"
				}}>A short survey</p>
				<p style={{
					fontSize:18	
				}}> {q} </p>
			</div>
				{this.props.children}
			{/* <div style={{
				position:"absolute",
				right: (360 - 114) / 2,
				bottom: 107,
				width:114,
				height:38,
				backgroundColor:global.blue,
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				cursor:"pointer"
			}} onClick={global.nextStage}>
				<span style={{
					color:"white"	
				}}>NEXT</span>
			</div> */}
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/dComp/shared/Q.js